const T = {
  fr: {
    landing: {
      navCta: 'Inscrire mon établissement',
      pill: 'Pour tous ceux qui cuisinent & cuisent 🔥',
      heroTitle1: 'Le four vient de sonner.',
      heroTitle2: 'Dites-le au monde.',
      heroSub: "HotNow permet à tous les professionnels de l'alimentation d'annoncer leurs produits frais en temps réel. Boulangers, sushimen, glaciers, rôtisseurs… vos clients affamés vous voient instantanément.",
      ctaVenue: "🏪 Inscrire mon établissement — c'est gratuit",
      ctaExplore: '🔍 Voir les fournées près de moi',
      liveBadge: 'Annonces en direct · mis à jour en temps réel',
      liveLabel: 'En direct près de vous',
      stats: [
        { value: '2 min', label: 'Pour annoncer une fournée' },
        { value: '100%', label: 'Gratuit pour démarrer' },
        { value: '2 h',  label: 'Fenêtre de fraîcheur en temps réel' },
      ],
      venuePill: 'Pour les établissements',
      venueTitle: 'Transformez chaque fournée en trafic immédiat',
      venueSub: "Vos clients n'ont rien à installer. Un appui et vous êtes en ligne.",
      venueSteps: [
        { icon: '📝', title: 'Inscrivez-vous en 30 secondes', desc: "Entrez le nom de votre établissement, son type et confirmez votre position GPS. C'est tout." },
        { icon: '📣', title: "Appuyez quand c'est prêt",      desc: 'Sélectionnez le produit, la quantité, appuyez sur le bouton. Votre annonce est en ligne instantanément.' },
        { icon: '🔥', title: 'Les clients arrivent',           desc: "Les clients affamés à proximité voient votre établissement apparaître en tête du fil HotNow." },
      ],
      typesPill: 'Qui peut rejoindre',
      typesTitle: 'Tous ceux qui cuisinent, cuisent ou rôtissent',
      typesSub: 'Si vous avez un four, HotNow est fait pour vous.',
      customerPill: 'Pour les clients',
      customerTitle: 'Ne ratez plus jamais une fournée',
      customerSub: "Voyez ce qui sort du four près de chez vous, maintenant.",
      customerSteps: [
        { icon: '📍', title: 'Ouvrez HotNow',          desc: "L'application vous montre toutes les fournées fraîches annoncées près de vous en ce moment." },
        { icon: '❤️', title: 'Sauvegardez vos favoris', desc: 'Mettez en favori vos boulangeries préférées et soyez alerté à la prochaine fournée.' },
        { icon: '🚶', title: 'Rendez-vous sur place',   desc: "Une barre de fraîcheur vous indique le temps qu'il vous reste avant que ce soit froid." },
      ],
      customerCta: '🔍 Voir les fournées près de moi',
      testimonialsPill: "Ce qu'ils en disent",
      testimonialsTitle: 'Ils ont essayé. Ils adorent.',
      testimonials: [
        { quote: "Mes croissants sont vendus 20 minutes après la sortie du four. HotNow m'a changé la vie.", name: 'Marie L.', role: 'Boulangère, Lyon', icon: '🥖' },
        { quote: "Je prépare mes plateaux sushi le midi, j'annonce sur HotNow et ils partent en 15 minutes.", name: 'Kenji T.', role: 'Sushiman, Paris', icon: '🍱' },
        { quote: "Ma file d'attente double les midis depuis que j'utilise HotNow. Incroyable.", name: 'Enzo R.', role: 'Pizzaïolo, Marseille', icon: '🍕' },
        { quote: 'Je sais exactement quand passer chez mon glacier préféré. Plus jamais de sorbet raté !', name: 'Sophie M.', role: 'Cliente, Bordeaux', icon: '🍦' },
      ],
      // ── Lead capture ──
      leadPill: 'Restez informé',
      leadTitle: 'Nouveau quartier, nouvelle adresse ?',
      leadSub: 'Laissez votre email et soyez prévenu quand un établissement près de chez vous rejoint HotNow.',
      leadPlaceholder: 'votre@email.com',
      leadBtn: 'Me prévenir',
      leadDone: '✅ C\'est noté ! On vous prévient dès qu\'il y a du neuf.',
      // ── Pricing ──
      pricingPill: 'Tarifs',
      pricingTitle: 'Simple. Transparent. Rentable.',
      pricingSub: 'Commencez gratuitement. Passez Pro quand vous êtes prêt.',
      plans: [
        {
          name: 'Gratuit',
          price: '0€',
          period: '',
          badge: null,
          desc: 'Pour démarrer et tester',
          features: [
            '5 annonces par jour',
            'Visible sur la carte',
            'Toutes les catégories',
            'Support par email',
          ],
          cta: 'Commencer gratuitement',
          ctaAction: 'register',
          highlight: false,
        },
        {
          name: 'Pro',
          price: '9,99€',
          period: '/mois',
          badge: '⭐ Recommandé',
          desc: 'Pour les pros du four',
          features: [
            'Annonces illimitées',
            'Badge Pro ⭐ sur votre fiche',
            'Priorité en tête de fil',
            'Statistiques de vues',
            'Support prioritaire',
          ],
          cta: 'Passer Pro →',
          ctaAction: 'stripe',
          highlight: true,
        },
      ],
      pricingNote: 'Sans engagement · Résiliable à tout moment',
      // ── CTA final ──
      ctaTitle1: 'Prêt à remplir votre',
      ctaTitle2: 'boutique à chaque fournée ?',
      ctaSub: 'Gratuit. 30 secondes. Sans carte bancaire. Sans engagement.',
      ctaFinal: '🏪 Inscrire mon établissement gratuitement',
      ctaNote: 'Vous gardez le contrôle. Supprimable à tout moment.',
      footerTagline: 'La fraîcheur en temps réel. Maintenant.',
    },
    app: {
      nearYou: '📍 Près de vous',
      savedSpots: '❤️ Mes favoris',
      appName: 'HotNow 🔥',
      myFavorites: 'Mes Favoris',
      searchPlaceholder: 'Boulangeries, sushis, glaciers, food trucks…',
      loading: 'Chargement des fournées…',
      live: 'en direct',
      noFavorites: 'Aucun favori',
      noFavoritesSub: "Sauvegardez des adresses en appuyant sur le ❤️.",
      nothingFresh: 'Rien de frais à proximité',
      nothingFreshSub: 'Les annonces restent visibles 2h après publication.',
      setupLabel: 'Configuration',
      dashboardTitle: 'Tableau de bord',
      registerTitle: 'Inscrire mon établissement',
      registerSub: 'Inscrivez votre établissement pour annoncer vos fournées en temps réel.',
      venueTypeLabel: "Type d'établissement",
      venueNameLabel: "Nom de l'établissement",
      venueNamePlaceholder: 'ex. Boulangerie Martin, Pizzeria Roma…',
      registerBtn: "📍 S'inscrire avec le GPS",
      registering: 'Inscription en cours…',
      announceTitle: 'Annoncer une fournée',
      productLabel: 'Produit',
      customPlaceholder: 'Ou tapez un produit personnalisé…',
      customPlaceholderOnly: 'Nom du produit…',
      quantityLabel: 'Quantité',
      announceBtn: '📣 Sorti du four MAINTENANT !',
      announcing: 'Publication…',
      liveNow: 'En ce moment',
      liveSuccess: '✅ En ligne ! Vos clients peuvent le voir.',
      nothingLive: "Rien d'annoncé pour l'instant. Appuyez sur le bouton !",
      switchVenue: "Changer d'établissement",
      locError: 'Impossible d\'obtenir votre position.',
      locErrorRetry: 'Réessayer',
      navDiscover: 'Découvrir',
      navFavorites: 'Favoris',
      navVenue: 'Mon lieu',
      // ── Plan / upgrade ──
      planFree: 'Plan Gratuit',
      planPro: 'Plan Pro ⭐',
      planBadgePro: '⭐ PRO',
      dailyLeft: (n) => `${n} annonce${n > 1 ? 's' : ''} restante${n > 1 ? 's' : ''} aujourd'hui`,
      dailyExhausted: 'Limite quotidienne atteinte',
      upgradeTitle: 'Passez Pro 🚀',
      upgradeSub: 'Annonces illimitées, badge Pro, priorité dans le fil.',
      upgradePrice: '9,99€ / mois',
      upgradeBtn: '⭐ Passer Pro maintenant',
      upgradeNote: 'Sans engagement · Résiliable à tout moment',
      upgradeLater: 'Peut-être plus tard',
      proActivated: '⭐ Plan Pro activé ! Bienvenue.',
      businessTypes: [
        { id: 'bakery',      icon: '🥖', label: 'Boulangerie' },
        { id: 'pizzeria',    icon: '🍕', label: 'Pizzeria' },
        { id: 'pastry',      icon: '🥐', label: 'Pâtisserie' },
        { id: 'restaurant',  icon: '🍽️', label: 'Restaurant' },
        { id: 'cafe',        icon: '☕', label: 'Café' },
        { id: 'fromagerie',  icon: '🧀', label: 'Fromagerie' },
        { id: 'boucherie',   icon: '🥩', label: 'Boucherie' },
        { id: 'traiteur',    icon: '🥗', label: 'Traiteur' },
        { id: 'glacier',     icon: '🍦', label: 'Glacier' },
        { id: 'foodtruck',   icon: '🚚', label: 'Food Truck' },
        { id: 'sushi',       icon: '🍱', label: 'Sushi / Japonais' },
        { id: 'chocolatier', icon: '🍫', label: 'Chocolatier' },
        { id: 'rotisserie',  icon: '🍗', label: 'Rôtisserie' },
        { id: 'creperie',    icon: '🥞', label: 'Crêperie' },
        { id: 'other',       icon: '🏪', label: 'Autre' },
      ],
      quantities: [
        { id: 'plenty', emoji: '🔥', label: 'Beaucoup',      sub: 'Grande fournée',  color: '#FF5000', bg: '#FFF0EB' },
        { id: 'some',   emoji: '✨', label: 'Quelques-uns',  sub: 'Limité',          color: '#FF9500', bg: '#FFF8EC' },
        { id: 'last',   emoji: '⚡', label: 'Les derniers !', sub: 'Vite !',          color: '#C0392B', bg: '#FDECEA' },
      ],
      freshnessLabels: { justOut: 'Tout chaud !', veryFresh: 'Très frais', fresh: 'Frais', stillWarm: 'Encore chaud', fading: 'Refroidit' },
      allFilter: '⚡ Tout',
      itemsMore: (n) => `+${n} produits`,
      timeAgo: (mins) => {
        if (mins < 1) return "à l'instant";
        if (mins < 60) return `il y a ${mins} min`;
        const h = Math.floor(mins / 60); return `il y a ${h}h${mins % 60 > 0 ? (mins % 60) + 'min' : ''}`;
      },
    },
  },

  en: {
    landing: {
      navCta: 'Register my venue',
      pill: 'For bakeries & food venues 🔥',
      heroTitle1: 'Your oven just beeped.',
      heroTitle2: 'Tell the world.',
      heroSub: 'HotNow lets every food professional announce fresh products in real time — bakers, sushi chefs, ice cream makers, rotisseries… hungry customers nearby find you instantly.',
      ctaVenue: "🏪 Register my venue — it's free",
      ctaExplore: '🔍 Explore fresh food near me',
      liveBadge: 'Live announcements · updated in real time',
      liveLabel: 'Live near you right now',
      stats: [
        { value: '2 min', label: 'To announce a fresh batch' },
        { value: '100%', label: 'Free to get started' },
        { value: '2 h',  label: 'Real-time freshness window' },
      ],
      venuePill: 'For venue owners',
      venueTitle: 'Turn hot batches into instant foot traffic',
      venueSub: "No app install needed for your customers. One tap and you're live.",
      venueSteps: [
        { icon: '📝', title: 'Register in 30 seconds', desc: "Enter your venue name, type and confirm your GPS position. That's it." },
        { icon: '📣', title: "Tap when it's out",       desc: 'Select the product, quantity level, press the button. Your announcement goes live instantly.' },
        { icon: '🔥', title: 'Customers rush in',       desc: 'Nearby hungry customers see your venue appear at the top of the HotNow feed.' },
      ],
      typesPill: 'Who can join',
      typesTitle: 'Every business that bakes, roasts or cooks',
      typesSub: 'If you have an oven, HotNow is for you.',
      customerPill: 'For customers',
      customerTitle: 'Never miss a fresh batch again',
      customerSub: "See what's just come out of the oven near you, right now.",
      customerSteps: [
        { icon: '📍', title: 'Open HotNow',       desc: 'The app shows you every fresh batch announced near you right now.' },
        { icon: '❤️', title: 'Save favourites',    desc: 'Bookmark your go-to bakeries and get notified the next time they announce.' },
        { icon: '🚶', title: 'Walk over',          desc: 'A freshness bar tells you how much time you have before it gets cold.' },
      ],
      customerCta: "🔍 See what's fresh near me",
      testimonialsPill: 'What they say',
      testimonialsTitle: 'They tried it. They love it.',
      testimonials: [
        { quote: 'My croissants sell out 20 minutes after leaving the oven. HotNow changed everything.', name: 'Marie L.', role: 'Bakery owner, Lyon', icon: '🥖' },
        { quote: 'I announce my sushi trays at noon and they sell out in 15 minutes flat. Unreal.', name: 'Kenji T.', role: 'Sushi chef, Paris', icon: '🍱' },
        { quote: 'My pizza queue doubles on lunch days now. Registered in under a minute.', name: 'Enzo R.', role: 'Pizzeria owner, Marseille', icon: '🍕' },
        { quote: 'I know exactly when to walk over to my favourite ice cream shop. Game changer.', name: 'Sophie M.', role: 'Customer, Bordeaux', icon: '🍦' },
      ],
      // ── Lead capture ──
      leadPill: 'Stay in the loop',
      leadTitle: 'New neighbourhood, new spots?',
      leadSub: 'Leave your email and we\'ll notify you when a venue near you joins HotNow.',
      leadPlaceholder: 'your@email.com',
      leadBtn: 'Notify me',
      leadDone: '✅ Saved! We\'ll ping you when there\'s something new nearby.',
      // ── Pricing ──
      pricingPill: 'Pricing',
      pricingTitle: 'Simple. Transparent. Profitable.',
      pricingSub: 'Start for free. Go Pro when you are ready.',
      plans: [
        {
          name: 'Free',
          price: '€0',
          period: '',
          badge: null,
          desc: 'To get started',
          features: [
            '5 announcements per day',
            'Visible on the map',
            'All categories',
            'Email support',
          ],
          cta: 'Start for free',
          ctaAction: 'register',
          highlight: false,
        },
        {
          name: 'Pro',
          price: '€9.99',
          period: '/month',
          badge: '⭐ Recommended',
          desc: 'For serious bakers',
          features: [
            'Unlimited announcements',
            'Pro badge ⭐ on your listing',
            'Priority at the top of the feed',
            'View statistics',
            'Priority support',
          ],
          cta: 'Go Pro →',
          ctaAction: 'stripe',
          highlight: true,
        },
      ],
      pricingNote: 'No commitment · Cancel anytime',
      // ── CTA final ──
      ctaTitle1: 'Ready to fill your',
      ctaTitle2: 'shop every bake?',
      ctaSub: 'Free. Takes 30 seconds. No credit card. No commitment.',
      ctaFinal: '🏪 Register my venue for free',
      ctaNote: 'You keep full control. Delete anytime.',
      footerTagline: 'Real-time food freshness. Right now.',
    },
    app: {
      nearYou: '📍 Near you',
      savedSpots: '❤️ Saved spots',
      appName: 'HotNow 🔥',
      myFavorites: 'My Favorites',
      searchPlaceholder: 'Bakeries, sushi, ice cream, food trucks…',
      loading: 'Loading fresh items…',
      live: 'live',
      noFavorites: 'No favorites yet',
      noFavoritesSub: 'Save spots by tapping the ❤️ on any card.',
      nothingFresh: 'Nothing fresh nearby',
      nothingFreshSub: 'Items appear up to 2h after being announced.',
      setupLabel: 'Setup',
      dashboardTitle: 'Dashboard',
      registerTitle: 'Register Venue',
      registerSub: 'Register your venue to start announcing fresh batches in real time.',
      venueTypeLabel: 'Type of venue',
      venueNameLabel: 'Venue name',
      venueNamePlaceholder: 'e.g. Boulangerie Martin, Pizzeria Roma…',
      registerBtn: '📍 Register with GPS',
      registering: 'Registering…',
      announceTitle: 'Announce a fresh batch',
      productLabel: 'Product',
      customPlaceholder: 'Or type a custom product…',
      customPlaceholderOnly: 'Product name…',
      quantityLabel: 'Quantity',
      announceBtn: '📣 Out of the oven NOW!',
      announcing: 'Publishing…',
      liveNow: 'Live right now',
      liveSuccess: '✅ Live! Customers can see it now.',
      nothingLive: 'Nothing announced yet. Hit the button above!',
      switchVenue: 'Switch venue',
      locError: 'Could not get your location.',
      locErrorRetry: 'Try again',
      navDiscover: 'Discover',
      navFavorites: 'Favorites',
      navVenue: 'My Venue',
      // ── Plan / upgrade ──
      planFree: 'Free Plan',
      planPro: 'Pro Plan ⭐',
      planBadgePro: '⭐ PRO',
      dailyLeft: (n) => `${n} announcement${n > 1 ? 's' : ''} left today`,
      dailyExhausted: 'Daily limit reached',
      upgradeTitle: 'Go Pro 🚀',
      upgradeSub: 'Unlimited announcements, Pro badge, priority in the feed.',
      upgradePrice: '€9.99 / month',
      upgradeBtn: '⭐ Go Pro now',
      upgradeNote: 'No commitment · Cancel anytime',
      upgradeLater: 'Maybe later',
      proActivated: '⭐ Pro plan activated! Welcome.',
      businessTypes: [
        { id: 'bakery',      icon: '🥖', label: 'Bakery' },
        { id: 'pizzeria',    icon: '🍕', label: 'Pizzeria' },
        { id: 'pastry',      icon: '🥐', label: 'Pastry Shop' },
        { id: 'restaurant',  icon: '🍽️', label: 'Restaurant' },
        { id: 'cafe',        icon: '☕', label: 'Café' },
        { id: 'fromagerie',  icon: '🧀', label: 'Cheese Shop' },
        { id: 'boucherie',   icon: '🥩', label: 'Butcher' },
        { id: 'traiteur',    icon: '🥗', label: 'Deli / Caterer' },
        { id: 'glacier',     icon: '🍦', label: 'Ice Cream' },
        { id: 'foodtruck',   icon: '🚚', label: 'Food Truck' },
        { id: 'sushi',       icon: '🍱', label: 'Sushi / Japanese' },
        { id: 'chocolatier', icon: '🍫', label: 'Chocolatier' },
        { id: 'rotisserie',  icon: '🍗', label: 'Rotisserie' },
        { id: 'creperie',    icon: '🥞', label: 'Creperie' },
        { id: 'other',       icon: '🏪', label: 'Other' },
      ],
      quantities: [
        { id: 'plenty', emoji: '🔥', label: 'Plenty',     sub: 'Large batch', color: '#FF5000', bg: '#FFF0EB' },
        { id: 'some',   emoji: '✨', label: 'A few',       sub: 'Limited',     color: '#FF9500', bg: '#FFF8EC' },
        { id: 'last',   emoji: '⚡', label: 'Last ones!',  sub: 'Hurry up',    color: '#C0392B', bg: '#FDECEA' },
      ],
      freshnessLabels: { justOut: 'Just out!', veryFresh: 'Very fresh', fresh: 'Fresh', stillWarm: 'Still warm', fading: 'Fading' },
      allFilter: '⚡ All',
      itemsMore: (n) => `+${n} items`,
      timeAgo: (mins) => {
        if (mins < 1) return 'just now';
        if (mins < 60) return `${mins}m ago`;
        const h = Math.floor(mins / 60); return `${h}h${mins % 60 > 0 ? (mins % 60) + 'm' : ''} ago`;
      },
    },
  },
};

export default T;
